import mutations from './plea.mutations'
import actions from './plea.actions'
import getters from './plea.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
